import {AgoraInterface} from "@share/web-conferences/interfaces/AgoraInterface";
import {ConnectionDisconnectedReason, ConnectionState} from "agora-rtc-sdk-ng";
import {AgoraConnectionStateInterface} from "@share/web-conferences/interfaces/AgoraConnectionStateInterface";
import {AgoraStates} from "@share/web-conferences/enums/AgoraStates";
import {GlobalEvents, GlobalEventTypes} from "@share/web-conferences/helpers/GlobalEvents";

export class AgoraConnectionState implements AgoraConnectionStateInterface {
    isReconnecting = false;
    currentState: ConnectionState | null = null;
    delayBeforeReconnectingState = 3000; //milliseconds
    timerId = -1;

    constructor(
        private readonly agora: AgoraInterface,
        private readonly globalEvents: GlobalEvents
    ) {
    }

    subscribe(): void {
        this.agora?.client.on("connection-state-change", this.stateChangeHandler.bind(this));
    }

    /**
     * If agora's status becomes RECONNECTING then we are gonna wait for delayBeforeReconnectingState milliseconds and
     * if after that it is still reconnecting we are gonna change the state and show the reconnecting message.
     * We do the delay because the agora's client time to time does reconnect while we are switching the camera or the mic on and off
     * So in order to be sure that we are really having a connectivity problem we wait for awhile
     * @param curState
     * @param revState
     * @param reason
     */
    async stateChangeHandler(curState: ConnectionState, revState: ConnectionState, reason?: ConnectionDisconnectedReason) {
        this.currentState = curState;
        clearTimeout(this.timerId);

        if (curState == AgoraStates.Reconnecting) {
            this.timerId = window.setTimeout(() => {
                if (this.currentState == AgoraStates.Reconnecting) {
                    this.isReconnecting = true;
                }
            }, this.delayBeforeReconnectingState)
        }
        else {
            this.isReconnecting = false;
        }

        if (curState == AgoraStates.Disconnected) {
            this.timerId = window.setTimeout(() => {
                if (this.currentState == AgoraStates.Disconnected && this.agora.joined) {
                    console.log('reconnecting');
                    this.agora.clean();
                    this.globalEvents.notify(GlobalEventTypes.Join);
                }
            }, this.delayBeforeReconnectingState)
        }
    }
}
